import { defineMessages } from "react-intl";
export default defineMessages({
    AQI: {
        id: "units.AQI",
        defaultMessage: "AQI",
    },
    AQI_24H: {
        id: "units.AQI_24H",
        defaultMessage: "24h AQI",
    },
    E: {
        id: "units.E",
        defaultMessage: "E",
    },
    ENE: {
        id: "units.ENE",
        defaultMessage: "ENE",
    },
    ENE_long: {
        id: "units.ENE_long",
        defaultMessage: "East-Northeast",
    },
    ESE: {
        id: "units.ESE",
        defaultMessage: "ESE",
    },
    ESE_long: {
        id: "units.ESE_long",
        defaultMessage: "East-Southeast",
    },
    ET: {
        id: "units.ET",
        defaultMessage: "Evapotranspiration",
    },
    ETshort: {
        id: "units.ETshort",
        defaultMessage: "ET",
    },
    E_long: {
        id: "units.E_long",
        defaultMessage: "East",
    },
    N: {
        id: "units.N",
        defaultMessage: "N",
    },
    NE: {
        id: "units.NE",
        defaultMessage: "NE",
    },
    NE_long: {
        id: "units.NE_long",
        defaultMessage: "Northeast",
    },
    NNE: {
        id: "units.NNE",
        defaultMessage: "NNE",
    },
    NNE_long: {
        id: "units.NNE_long",
        defaultMessage: "North-Northeast",
    },
    NNW: {
        id: "units.NNW",
        defaultMessage: "NNW",
    },
    NNW_long: {
        id: "units.NNW_long",
        defaultMessage: "North-Northwest",
    },
    NW: {
        id: "units.NW",
        defaultMessage: "NW",
    },
    NW_long: {
        id: "units.NW_long",
        defaultMessage: "Northwest",
    },
    N_long: {
        id: "units.N_long",
        defaultMessage: "North",
    },
    O3: {
        id: "units.O3",
        defaultMessage: "Ozone",
    },
    PM_1: {
        id: "units.PM_1",
        defaultMessage: "PM1",
    },
    PM_10: {
        id: "units.PM_10",
        defaultMessage: "PM10",
    },
    PM_2P5: {
        id: "units.PM_2P5",
        defaultMessage: "PM2.5",
    },
    S: {
        id: "units.S",
        defaultMessage: "S",
    },
    SE: {
        id: "units.SE",
        defaultMessage: "SE",
    },
    SE_long: {
        id: "units.SE_long",
        defaultMessage: "Southeast",
    },
    SSE: {
        id: "units.SSE",
        defaultMessage: "SSE",
    },
    SSE_long: {
        id: "units.SSE_long",
        defaultMessage: "South-Southeast",
    },
    SSW: {
        id: "units.SSW",
        defaultMessage: "SSW",
    },
    SSW_long: {
        id: "units.SSW_long",
        defaultMessage: "South-Southwest",
    },
    SW: {
        id: "units.SW",
        defaultMessage: "SW",
    },
    SW_long: {
        id: "units.SW_long",
        defaultMessage: "Southwest",
    },
    S_long: {
        id: "units.S_long",
        defaultMessage: "South",
    },
    W: {
        id: "units.W",
        defaultMessage: "W",
    },
    WNW: {
        id: "units.WNW",
        defaultMessage: "WNW",
    },
    WNW_long: {
        id: "units.WNW_long",
        defaultMessage: "West-Northwest",
    },
    WSW: {
        id: "units.WSW",
        defaultMessage: "WSW",
    },
    WSW_long: {
        id: "units.WSW_long",
        defaultMessage: "West-Southwest",
    },
    W_long: {
        id: "units.W_long",
        defaultMessage: "West",
    },
    absolutePressure: {
        id: "units.absolutePressure",
        defaultMessage: "Absolute pressure",
    },
    airDensity: {
        id: "units.airDensity",
        defaultMessage: "Air density",
    },
    apparentTemperature: {
        id: "units.apparentTemperature",
        defaultMessage: "Apparent temperature",
    },
    avg: {
        id: "units.avg",
        defaultMessage: "Avg.",
    },
    beaufort: {
        id: "units.beaufort",
        defaultMessage: "Beaufort",
    },
    boilerOn: {
        id: "units.boilerOn",
        defaultMessage: "Boiler ON",
    },
    co2: {
        id: "units.co2",
        defaultMessage: "CO2",
    },
    coolingDegreeDays: {
        id: "units.coolingDegreeDays",
        defaultMessage: "Cooling degree days",
    },
    dailyHeatingDuration: {
        id: "units.dailyHeatingDuration",
        defaultMessage: "Daily heating duration",
    },
    dailyPrecipitation: {
        id: "units.dailyPrecipitation",
        defaultMessage: "Daily precipitation",
    },
    dailyRain: {
        id: "units.dailyRain",
        defaultMessage: "Daily rain",
    },
    degreeDay: {
        id: "units.degreeDay",
        defaultMessage: "Degree day",
    },
    degreeDayShort: {
        id: "units.degreeDayShort",
        defaultMessage: "DD",
    },
    dewPoint: {
        id: "units.dewPoint",
        defaultMessage: "Dew point",
    },
    distance: {
        id: "units.distance",
        defaultMessage: "Distance",
    },
    downTrend: {
        id: "units.downTrend",
        defaultMessage: "down",
    },
    feelLike: {
        id: "units.feelLike",
        defaultMessage: "Feels-like",
    },
    footMile: {
        id: "units.footMile",
        defaultMessage: "Foot, mile",
    },
    frostPoint: {
        id: "units.frostPoint",
        defaultMessage: "Frost point",
    },
    feelsLike: {
        id: "units.feelsLike",
        defaultMessage: "Feels like",
    },
    gust: {
        id: "units.gust",
        defaultMessage: "Gust",
    },
    heatIndex: {
        id: "units.heatIndex",
        defaultMessage: "Heat index",
    },
    heatingDegreeDays: {
        id: "units.heatingDegreeDays",
        defaultMessage: "Heating degree days",
    },
    heatingPower: {
        id: "units.heatingPower",
        defaultMessage: "Heating power",
    },
    humidex: {
        id: "units.humidex",
        defaultMessage: "Humidex",
    },
    humidity: {
        id: "units.humidity",
        defaultMessage: "Humidity",
    },
    inch: {
        id: "units.inch",
        defaultMessage: "Inch",
    },
    inchOfMercury: {
        id: "units.inchOfMercury",
        defaultMessage: "Inch of mercury",
    },
    kilometerPerHour: {
        id: "units.kilometerPerHour",
        defaultMessage: "Kilometers per hour",
    },
    knot: {
        id: "units.knot",
        defaultMessage: "Knot",
    },
    lastHour: {
        id: "units.lastHour",
        defaultMessage: "Last Hour",
    },
    last3Hours: {
        id: "units.last3Hours",
        defaultMessage: "Last 3 Hours",
    },
    last6Hours: {
        id: "units.last6Hours",
        defaultMessage: "Last 6 Hours",
    },
    last12Hours: {
        id: "units.last12Hours",
        defaultMessage: "Last 12 Hours",
    },
    last24Hours: {
        id: "units.last24Hours",
        defaultMessage: "Last 24 Hours",
    },
    lastLightningImpact: {
        id: "units.lastLightningImpact",
        defaultMessage: "Last impact",
    },
    lastMeasure: {
        id: "units.lastMeasure",
        defaultMessage: "Last measure",
    },
    leafSensors: {
        id: "units.leafSensors",
        defaultMessage: "Leaf sensors",
    },
    depthSensors: {
        id: "units.depthSensors",
        defaultMessage: "Depth sensors",
    },
    depth: {
        id: "units.depth",
        defaultMessage: "Depth",
    },
    airGap: {
        id: "units.airGap",
        defaultMessage: "Air gap",
    },
    leafWetness: {
        id: "units.leafWetness",
        defaultMessage: "Leaf wetness",
    },
    lightningDistance: {
        id: "units.lightningDistance",
        defaultMessage: "Distance",
    },
    lightningStrikeCount: {
        id: "units.lightningStrikeCount",
        defaultMessage: "Lightning strike count",
    },
    lightningStrikeDistance: {
        id: "units.lightningStrikeDistance",
        defaultMessage: "Lightning strike distance",
    },
    max: {
        id: "units.max",
        defaultMessage: "Max.",
    },
    max_gust: {
        id: "units.max_gust",
        defaultMessage: "Max. gust",
    },
    max_wind: {
        id: "units.max_wind",
        defaultMessage: "Max. wind",
    },
    meterKilometer: {
        id: "units.meterKilometer",
        defaultMessage: "Meter, kilometer",
    },
    meterPerSecond: {
        id: "units.meterPerSecond",
        defaultMessage: "Meters per second",
    },
    milePerHour: {
        id: "units.milePerHour",
        defaultMessage: "Miles per hour",
    },
    millibar: {
        id: "units.millibar",
        defaultMessage: "Millibar",
    },
    millimeter: {
        id: "units.millimeter",
        defaultMessage: "Millimeter",
    },
    millimeterOfMercury: {
        id: "units.millimeterOfMercury",
        defaultMessage: "Millimeter of mercury",
    },
    min: {
        id: "units.min",
        defaultMessage: "Min.",
    },
    noise: {
        id: "units.noise",
        defaultMessage: "Noise",
    },
    normalizedHeatingCoefficient: {
        id: "units.normalizedHeatingCoefficient",
        defaultMessage: "Normalized heating coefficient",
    },
    precipitation: {
        id: "units.precipitation",
        defaultMessage: "Precipitation",
    },
    pressure: {
        id: "units.pressure",
        defaultMessage: "Pressure",
    },
    rain: {
        id: "units.rain",
        defaultMessage: "Rain",
    },
    rainRate: {
        id: "units.rainRate",
        defaultMessage: "Rain rate",
    },
    referenceTemperature: {
        id: "units.referenceTemperature",
        defaultMessage: "Reference temperature",
    },
    relativePressure: {
        id: "units.relativePressure",
        defaultMessage: "Relative pressure",
    },
    setPoint: {
        id: "units.setPoint",
        defaultMessage: "Setpoint",
    },
    snow: {
        id: "units.snow",
        defaultMessage: "Snow",
    },
    snowfall: {
        id: "units.snowfall",
        defaultMessage: "Snowfall",
    },
    soilMoisture: {
        id: "units.soilMoisture",
        defaultMessage: "Moisture",
    },
    conductivity: {
        id: "units.conductivity",
        defaultMessage: "Conductivity",
    },
    soilSensors: {
        id: "units.soilSensors",
        defaultMessage: "Soil sensors",
    },
    solarEnergy: {
        id: "units.solarEnergy",
        defaultMessage: "Solar energy",
    },
    solarRadiation: {
        id: "units.solarRadiation",
        defaultMessage: "Solar radiation",
    },
    speed: {
        id: "units.speed",
        defaultMessage: "Speed",
    },
    stableTrend: {
        id: "units.stableTrend",
        defaultMessage: "stable",
    },
    sum: {
        id: "units.sum",
        defaultMessage: "Sum",
    },
    temperature: {
        id: "units.temperature",
        defaultMessage: "Temperature",
    },
    temperatureAndHumiditySensors: {
        id: "units.temperatureAndHumiditySensors",
        defaultMessage: "Temperature & humidity sensors",
    },
    temperatureSensors: {
        id: "units.temperatureSensors",
        defaultMessage: "Temperature & humidity sensors",
    },
    thsw: {
        id: "units.thsw",
        defaultMessage: "THSW",
    },
    thw: {
        id: "units.thw",
        defaultMessage: "THW",
    },
    today: {
        id: "units.today",
        defaultMessage: "Today",
    },
    upTrend: {
        id: "units.upTrend",
        defaultMessage: "up",
    },
    uv: {
        id: "units.uv",
        defaultMessage: "UV",
    },
    visibility: {
        id: "units.visibility",
        defaultMessage: "Visibility",
    },
    wetBulbGlobeTemperature: {
        id: "units.wetBulbGlobeTemperature",
        defaultMessage: "Wet bulb globe temp.",
    },
    blackGlobeTemperature: {
        id: "units.blackGlobeTemperature",
        defaultMessage: "Black globe temp.",
    },
    wetBulbTemperature: {
        id: "units.wetBulbTemperature",
        defaultMessage: "Wet bulb temp.",
    },
    wind: {
        id: "units.wind",
        defaultMessage: "Wind",
    },
    windChill: {
        id: "units.windChill",
        defaultMessage: "Wind chill",
    },
    windDirection: {
        id: "units.windDirection",
        defaultMessage: "Wind direction",
    },
    windRun: {
        id: "units.windRun",
        defaultMessage: "Wind run",
    },
    windRunDescription: {
        id: "units.windRunDescription",
        defaultMessage: "The wind run is the total distance of the traveled wind over a period of time",
    },
});
